import React from 'react';
import { Route, Switch } from 'react-router-dom';

import Can from '~/contexts/Can';
import NotPermissionPage from '~/pages/NotPermissionPage';

import List from './List';
import { MedicalAppointmentsReportsProvider } from './context';

function MedicalAppointmentsReports() {
  return (
    <MedicalAppointmentsReportsProvider>
      <Switch>
        <Route
          render={(props) => (
            <>
              <Can I="list" a="MedicalAppointmentsReports">
                {() => <List {...props} />}
              </Can>
              <Can not I="list" a="MedicalAppointmentsReports">
                {() => <NotPermissionPage />}
              </Can>
            </>
          )}
        />
      </Switch>
    </MedicalAppointmentsReportsProvider>
  );
}
export default MedicalAppointmentsReports;
